import { cn } from '@/lib/utils';

export interface LoadingStateProps {
  /** Text under the spinner; the caller translates it. */
  label?: string;
  /** Fills the viewport, for route-level loading. */
  fullscreen?: boolean;
  className?: string;
}

/** Spinner with a label, announced as a live status region. */
export function LoadingState({
  label = 'Lädt …',
  fullscreen = false,
  className,
}: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center gap-3',
        fullscreen ? 'min-h-screen bg-paper' : 'py-12',
        className
      )}
    >
      <span
        className="h-8 w-8 animate-spin rounded-pill border-2 border-line border-t-primary"
        aria-hidden="true"
      />
      <p className="text-sm text-ink-2">{label}</p>
    </div>
  );
}
